<div class="dx-card wide-card">
    <h4 class="content-block ap-green">List All Plants</h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="sm">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>

            <dxi-item class="marginB10">
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label">Show Merchant LB</div>
                    <div class="dx-field-value">
                        <dx-radio-group [dataSource]="materialLBValues" [(value)]="materialLBValue" name="MaterialLB"
                            layout="horizontal" (onValueChanged)="filterChanged($event)">
                        </dx-radio-group>
                    </div>
                </div>

            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label">Show Onsite</div>
                    <div class="dx-field-value">
                        <dx-radio-group [dataSource]="onsiteValues" [(value)]="onsiteValue" name="Onsite"
                            layout="horizontal" (onValueChanged)="filterChanged($event)">
                        </dx-radio-group>
                    </div>
                </div>
            </dxi-item>
        </dx-responsive-box>
    </div>
    <hr />
    <dx-data-grid class="fixGridHeight" id="AllPlantsReportGrid" [dataSource]="allPlantsReportData"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true"
        [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel" location="before">All Plants as of <b>{{currentDate | date:'shortDate'
                    }}</b></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="plantCoSite" caption="PlantCo Site" [width]="120"></dxi-column>
        <dxi-column dataField="isNotRunning" caption="Is not running" [width]="100"></dxi-column>
        <dxi-column dataField="siteName" [width]="120"></dxi-column>
        <dxi-column dataField="isJV" [width]="80"></dxi-column>
        <dxi-column dataField="isRealPlant" [width]="100"></dxi-column>
        <dxi-column dataField="physicallyThereFlag" caption="Is Physically There Now" [width]="120"></dxi-column>
        <dxi-column dataField="company" [width]="120"></dxi-column>
        <dxi-column dataField="address" caption="Address EN" [width]="120"></dxi-column>
        <dxi-column dataField="city" [width]="120"></dxi-column>
        <dxi-column dataField="province" caption="State/Province" [width]="120"></dxi-column>
        <dxi-column dataField="countryName" [width]="120"></dxi-column>
        <dxi-column dataField="worldRegion" [width]="120"></dxi-column>
        <dxi-column dataField="subRegion" [width]="120"></dxi-column>
        <dxi-column dataField="zipCode" [width]="120"></dxi-column>
        <dxi-column dataField="lbu" caption="LBU" [width]="120"></dxi-column>
        <dxi-column dataField="latitude" [width]="120"></dxi-column>
        <dxi-column dataField="longitude" [width]="120"></dxi-column>
        <dxi-column dataField="captiveLiq" [width]="100"></dxi-column>
        <dxi-column dataField="hasMerchantLINorLOX" [width]="100"></dxi-column>
        <dxi-column dataField="hasMerchantLINonly" [width]="100"></dxi-column>
        <dxi-column dataField="larFlag" [width]="100"></dxi-column>
        <dxi-column dataField="ganFlag" [width]="100"></dxi-column>
        <dxi-column dataField="goxFlag" [width]="100"></dxi-column>
        <dxi-column dataField="lheFlag" [width]="100"></dxi-column>
        <dxi-column dataField="lHyFlag" [width]="100"></dxi-column>
        <dxi-column dataField="bHyFlag" [width]="100"></dxi-column>
        <dxi-column dataField="liquifierType" [width]="120"></dxi-column>
        <dxi-column dataField="hostCustomer" [width]="120"></dxi-column>
        <dxi-column dataField="capacity" caption="Merchant LIN+LOX MTD" [width]="120"></dxi-column>
        <dxi-column dataField="liNasEntered" [width]="120" caption="Merchant LINLOX as Entered"></dxi-column>
        <dxi-column dataField="laR_TPD" [width]="80" caption="Merchant LAR MTD"></dxi-column>
        <dxi-column dataField="larAsEntered" [width]="120" caption="Merchant LAR as Entered"></dxi-column>
        <dxi-column dataField="cO2VolumeTPD" caption="LCO2 Volume TPD" [width]="120"></dxi-column>
        <dxi-column dataField="cO2AsEntered" caption="LCO2 As Entered" [width]="120"></dxi-column>
        <dxi-column dataField="sourceOfGas" caption="Source of LCO2" [width]="120"></dxi-column>
        <dxi-column dataField="lhyVolumeTPD" caption="LHy MTD" [width]="120"></dxi-column>
        <dxi-column dataField="bHy_knm3h" caption="BHy_knm3/h" [width]="120"></dxi-column>
        <dxi-column dataField="nsF60CertifiedFlag" caption="NSF60 Certified" [width]="120"></dxi-column>
        <dxi-column dataField="isTG_ASU" caption="Is tg SOG ASU (tg=Tonnage)" [width]="120"></dxi-column>
        <dxi-column dataField="tgGAN" caption="tg GAN MTD" [width]="120"></dxi-column>
        <dxi-column dataField="tgGOX" caption="tg GOX MTD" [width]="120"></dxi-column>
        <dxi-column dataField="tgLAR" caption="tg LAR MTD" [width]="80"></dxi-column>
        <dxi-column dataField="comment" [width]="150"></dxi-column>
        <dxi-column dataField="shutdownDate" dataType="datetime" format="shortDate" [width]="120"></dxi-column>
        <dxi-column dataField="shutdownFlag" [width]="120"></dxi-column>
        <dxi-column dataField="dismantledFlag" dataType="Is Dismantled" [width]="80"></dxi-column>
        <dxi-column dataField="sapPlantID" [width]="90"></dxi-column>
        <dxi-column dataField="sapPlantName" [width]="120"></dxi-column>
        <dxi-column dataField="siteInsertedBy" [width]="120"></dxi-column>
        <dxi-column dataField="siteInsertedOn" dataType="datetime" [width]="120"></dxi-column>
        <dxi-column dataField="siteModifiedBy" [width]="120"></dxi-column>
        <dxi-column dataField="siteModifiedOn" dataType="datetime" [width]="120"></dxi-column>
        <dxi-column dataField="prodModifiedBy" [width]="120"></dxi-column>
        <dxi-column dataField="prodModifiedOn" dataType="datetime" [width]="120"></dxi-column>
        <dxi-column dataField="siteID" caption="Do Not Delete SiteID" [width]="80"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>